import * as qz from 'qz-tray'

import { qzPrintService } from '@/services'

const PUBLIC_CERT_PATH = '/cert/public-cert.pem'

export default class PrinterUtil {
  constructor() {}

  async setup(): Promise<void> {
    qz.security.setCertificatePromise(async () => {
      const res = await fetch(PUBLIC_CERT_PATH)
      const cert = await res.text()
      console.log('加载证书')
      return cert
    })

    qz.security.setSignatureAlgorithm('SHA512')
    qz.security.setSignaturePromise(async (toSign) => {
      console.log('待签名', toSign)
      return qzPrintService.getSign(toSign)
    })
  }

  async connect(host?: string): Promise<void> {
    try {
      if (!qz.websocket.isActive()) {
        if (host) {
          const options: qz.ConnectOptions = {
            host
          }
          await qz.websocket.connect(options)
        } else {
          await qz.websocket.connect()
        }
        console.log('✅ 打印机连接完成')
      } else {
        console.log('⚡️ 已经连接，无需重复连接')
      }
    } catch (err) {
      console.error('❌ 连接失败:', err)
      throw err
    }
  }

  async disconnect() {
    try {
      if (qz.websocket.isActive()) {
        await qz.websocket.disconnect()
        console.log('✅ 打印机关闭完成')
      } else {
        console.log('⚡️ 已经关闭，无需重复关闭')
      }
    } catch (err) {
      console.error('❌ 关闭失败:', err)
      throw err
    }
  }

  async getPrinters(): Promise<string[]> {
    if (!qz.websocket.isActive()) {
      throw Error('❗️打印机未连接')
    }
    const allPrinters = await qz.printers.find()
    return Array.isArray(allPrinters) ? allPrinters : [allPrinters]
  }

  async getDefaultPrinter(): Promise<string> {
    if (!qz.websocket.isActive()) {
      throw Error('❗️打印机未连接')
    }
    return await qz.printers.getDefault()
  }

  async printToHTML(
    name: string,
    content: string | string[],
    size: qz.Size
  ): Promise<void> {
    if (!qz.websocket.isActive()) {
      throw Error('❗️打印机未连接')
    }

    try {
      const config = qz.configs.create(name, {
        size: size,
        units: 'mm',
        margins: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        scaleContent: false, // 等比例缩放
        orientation: 'portrait' // 或 'landscape'
      })

      if (Array.isArray(content)) {
        console.log(`准备打印多页内容 - 共${content.length}页`)
        // 多页处理：用分页符连接各页内容
        content.map(async (page, index) => {
          console.log(`准备打印第${index + 1}页内容`)
          await qz.print(config, [
            {
              flavor: 'plain',
              type: 'pixel',
              format: 'html',
              data: page
            }
          ])
        })
      } else {
        // 单页处理
        console.log('准备打印单页内容', config)
        await qz.print(config, [
          {
            flavor: 'plain',
            type: 'pixel',
            format: 'html',
            data: content
          }
        ])

        console.log('打印成功')
      }
    } catch (error) {
      console.warn('打印失败：' + error)
      throw error
    }
  }
}
